<template>
    <div class="el-main-content">
        <div class="el-grid-card el-grid-card--no-style calendar-main-wrapper">
            <div class="el-row">
                <v-btn-toggle class="btn-calendar-group">
                    <v-btn
                        flat
                        color="dark"
                        class="btn-calendar-sm"
                        @click="prevWeek"
                    >
                        <v-icon dark>keyboard_arrow_left</v-icon>
                    </v-btn>
                </v-btn-toggle>

                <el-date-picker
                    class="top-calendar-picker"
                    id="calendarDate"
                    v-model="date"
                    format="yyyy-MM-dd"
                    type="date"
                    :picker-options="pickerOptions"
                >
                </el-date-picker>

                <v-btn-toggle v-model="activeButton" class="btn-calendar-group">
                    <v-btn
                        flat
                        color="dark"
                        class="btn-calendar-auto"
                        @click="date = today"
                    >
                        {{ $t('button.text.currentWeek') }}
                    </v-btn>
                    <v-btn
                        flat
                        color="dark"
                        class="btn-calendar-auto"
                        @click="
                            $refs.bookingCalendar.fireMethod(
                                'changeView',
                                'agendaFiveDays'
                            )
                        "
                    >
                        {{ $t('button.text.days', { number: 5 }) }}
                    </v-btn>
                    <v-btn
                        flat
                        color="dark"
                        class="btn-calendar-auto"
                        @click="
                            $refs.bookingCalendar.fireMethod(
                                'changeView',
                                'agendaSevenDays'
                            )
                        "
                    >
                        {{ $t('button.text.days', { number: 7 }) }}
                    </v-btn>
                    <v-btn
                        flat
                        color="dark"
                        class="btn-calendar-sm"
                        @click="nextWeek"
                    >
                        <v-icon dark>keyboard_arrow_right</v-icon>
                    </v-btn>
                </v-btn-toggle>

                <div>
                    <el-row>
                        <el-col style="padding-left: 10px" :span="1">
                            <v-icon
                                class="icon-default"
                                @click.stop="defaultView = 'agendaDay'"
                                >calendar_view_day</v-icon
                            >
                            <span style="font-size: 12px">{{
                                $t('data.label.day')
                            }}</span>
                        </el-col>
                        <el-col :span="1">
                            <v-icon
                                class="icon-default"
                                @click.stop="
                                    defaultView = isWeekend
                                        ? 'agendaSevenDays'
                                        : 'agendaFiveDays'
                                "
                                >calendar_today</v-icon
                            >
                            <span style="font-size: 12px">{{
                                $t('data.label.week')
                            }}</span>
                        </el-col>
                    </el-row>
                </div>

                <span class="week-number">
                    <span class="week__text">
                        {{ $t('data.label.week') }}:
                    </span>
                    <span class="week__number">
                        {{ weekOfYear }}
                    </span>
                </span>
            </div>
            <full-calendar
                ref="bookingCalendar"
                :config="config"
                :header="header"
                :defaultView="defaultView"
                @event-render="renderBooking"
                @event-selected="selectBooking"
                @event-created="addBooking"
                @event-drop="updateBooking"
                @event-resize="updateBooking"
                :events="calendarBookings"
                class="highlight-day"
            />
        </div>
        <div
            class="el-form-card el-form-card--right--cal"
            :class="{ 'el-form-card--collapse': collapseBooking }"
        >
            <div class="el-form-card__header">
                <div
                    class="el-form-card__header-left-icon"
                    @click="setBookingCollapsed(!collapseBooking)"
                >
                    <img
                        class="inline-block mt-2"
                        src="/images/icon/bookings.png"
                    />
                </div>
                <div
                    class="el-form-card__header-text custom_font_1"
                    style="
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 75%;
                    "
                >
                    {{ $t('form.title.calendarSettings') }}
                </div>
                <div
                    class="el-form-card__header-right-icon"
                    @click="setBookingCollapsed(!collapseBooking)"
                >
                    <img src="/images/icon/minimize.png" />
                </div>
            </div>
            <div class="el-form-card__body">
                <div class="el-form-card__collapse-label custom_font_1">
                    {{ $t('form.title.calendarSettings') }}
                </div>
                <div
                    class="el-form-card-mini"
                    v-if="
                        selectedContainer.AvailableBookingTypes.includes('WA')
                    "
                >
                    <div
                        class="el-form-card__header el-form-card__header-center"
                    >
                        {{ $t('form.title.waitingArea') }}
                    </div>
                    <div class="el-form-card__element-wrapper">
                        <div class="el-radio-list">
                            <v-radio-group class="calendar-filter-list-group">
                                <v-layout
                                    v-for="waitingAreaType in waitingAreaTypes"
                                    :key="waitingAreaType.value"
                                >
                                    <v-flex xs1>
                                        <v-checkbox
                                            :value="waitingAreaType.value"
                                            :input-value="waitingAreaType.value"
                                            v-model="selectedWaitingAreaTypes"
                                            color="success"
                                            hide-details
                                        />
                                    </v-flex>
                                    <v-flex xs11>
                                        <span
                                            v-bind:class="
                                                waitingAreaType.styleClass
                                            "
                                            class="wa-type-selector"
                                        >
                                            {{
                                                $t(
                                                    'form.label.' +
                                                        waitingAreaType.text
                                                )
                                            }}
                                        </span>
                                    </v-flex>
                                </v-layout>
                            </v-radio-group>
                        </div>
                    </div>
                </div>
                <div class="el-form-card-mini" v-if="unloadingAreas.length">
                    <stc-unloading-areas-selctor
                        :unloadingAreas="unloadingAreas"
                        :showPass="
                            selectedContainer.AvailableBookingTypes &&
                            selectedContainer.AvailableBookingTypes.includes(
                                'PASS'
                            )
                        "
                        @unloading-area-checked="unloadingAreasChecked"
                        @unloading-area-selected="setSelectedUnloadingArea"
                    ></stc-unloading-areas-selctor>
                </div>
                <div class="el-form-card-mini">
                    <div
                        class="el-form-card__header el-form-card__header-center"
                    >
                        {{ $t('form.title.bookingDetails') }}
                    </div>
                    <div class="el-form-card__element-wrapper">
                        <draggable
                            class="list-group"
                            tag="ul"
                            v-bind="dragOptions"
                            v-model="bookingDetailsArr"
                            @start="drag = true"
                            @end="drag = false"
                        >
                            <transition-group
                                type="transition"
                                :name="!drag ? 'flip-list' : null"
                            >
                                <li
                                    class="list-group-item"
                                    v-for="element in bookingDetailsArr"
                                    :key="element.id"
                                    style="display: flex"
                                >
                                    <i class="el-icon-rank draggable_icon"></i>
                                    <v-checkbox
                                        :label="$t(element.text)"
                                        v-model="element.checked"
                                        color="success"
                                        hide-details
                                        class="booking-details"
                                        @change="handleCheckBoxChange($event)"
                                    />
                                    <v-switch
                                        height="200"
                                        class="highlight_section"
                                        v-model="element.isHighlighted"
                                        @change="
                                            handleBookingDetailsHighlightChange
                                        "
                                    />
                                </li>
                            </transition-group>
                        </draggable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { DateTime } from 'luxon'
import { mapActions, mapGetters } from 'vuex'
import FullCalendar from '../Calender'
import draggable from 'vuedraggable'
import InteractWithDates from '../../mixins/interact-with-dates'
import BookingEventComponent from './BookingEvent'
import BookingNotificationEventComponent from './BookingNotificationEvent'
import BookingCreateEventComponent from './BookingCreateEvent'
import WANotificationEventComponent from './WANotificationEvent.vue'
import UnloadingAreasSelectorComponent from './UnloadingAreasSelector.vue'
import UnloadingAreasMixin from '../../mixins/unloading-areas-mixin'

let BookingEvent = Vue.extend(BookingEventComponent)
let BookingNotificationEvent = Vue.extend(BookingNotificationEventComponent)
let BookingCreateEvent = Vue.extend(BookingCreateEventComponent)
let WANotificationEvent = Vue.extend(WANotificationEventComponent)

export default {
    data() {
        let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

        let date = DateTime.local().toJSDate()

        return {
            date,
            dateTimeFormat,
            activeButton: 1,
            popoverElements: [],
            header: {
                left: '',
                center: '',
                right: '',
            },
            rawBookings: [],
            rawNotifications: [],
            rawWANotifications: [],
            dateTimeRange: [],
            unloadingAreaList: [],
            weekOfYear: '',
            selectedUnloadingArea: undefined,
            drag: false,
            defaultView: '',
            isWeekend: false,
            waitingAreaTypes: [
                {
                    value: 0,
                    text: 'proposed',
                    styleClass: 'wa-type-selector-proposed',
                },
                {
                    value: 3,
                    text: 'expected',
                    styleClass: 'wa-type-selector-expected',
                },
                {
                    value: 1,
                    text: 'confirmed',
                    styleClass: 'wa-type-selector-confirmed',
                },
                {
                    value: 2,
                    text: 'denied',
                    styleClass: 'wa-type-selector-denied',
                },
            ],
            selectedWaitingAreaTypes: [0, 3],
        }
    },
    created: async function () {
        await this.getUnloadingAreas()

        this.weekOfYear = this.currentWeek

        Events.$on('actor-updated', () => {
            // this.fetchByWeekNumber(this.weekOfYear)
        })

        Events.$on('actor-created', () => {
            this.fetchByWeekNumber(this.weekOfYear)
        })

        Events.$on('notification-deleted', () => {
            this.fetchByWeekNumber(this.weekOfYear)
        })

        Events.$on('calendar-refresh', (res) => {
            this.date = res[0]
            this.fetchByWeekNumber(this.weekOfYear)
        })

        Events.$on('calendar-refresh-from-notifications', () => {
            this.$nextTick(() => {
                this.fetchByWeekNumber(this.weekOfYear)
            })
        })

        Events.$on('scroll-calendar', (scrollHour) => {
            const scrollToElement = this.$refs.bookingCalendar.$el
                .getElementsByClassName('fc-slats')[0]
                .querySelectorAll('tr[data-time*="' + scrollHour + ':00"]')
            const elementOffsetTop =
                scrollToElement && scrollToElement.length > 0
                    ? scrollToElement[0].offsetTop
                    : 0
            this.$refs.bookingCalendar.$el.getElementsByClassName(
                'fc-scroller'
            )[0].scrollTop = elementOffsetTop
        })
    },

    beforeDestroy() {
        Events.$off('notification-deleted')
        Events.$off('actor-updated')
        Events.$off('scroll-calendar')
        Events.$off('calendar-refresh-from-notifications')
    },

    mixins: [InteractWithDates, UnloadingAreasMixin],

    components: {
        'full-calendar': FullCalendar,
        'stc-unloading-areas-selctor': UnloadingAreasSelectorComponent,
        draggable,
    },

    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost',
            }
        },

        bookingDetailsArr: {
            get() {
                return this.$store.getters.getBookingDetails()
            },
            set(value) {
                this.$store.commit('setBookingDetails', value)
                this.fetchByWeekNumber(this.weekOfYear)
            },
        },

        bookings() {
            let bookings = this.rawBookings.map((item) => {
                let accessSet = item.AccessSets[0]
                let schedulePart = accessSet.Schedules[0].ScheduleParts[0]

                return {
                    ...item,
                    DateFrom: DateTime.fromString(
                        schedulePart.ValidFrom,
                        this.dateTimeFormat
                    ),
                    DateTo: DateTime.fromString(
                        schedulePart.ValidTo,
                        this.dateTimeFormat
                    ),
                    UnloadingArea: accessSet.Checkpoint,
                    UnloadingAreaID: accessSet.UnloadingAreaID,
                    requestedResources: accessSet.RequestedResources,
                    PackageGroups: item.PackageGroups,
                }
            })

            bookings = bookings.filter(
                (item) => item.ActorType !== 'TENTATIVE' || item.Status !== 2
            )

            if (this.unloadingAreaList.length === 0) {
                bookings = []
            }

            return bookings.filter((item) => {
                return this.unloadingAreaList.some((check) => {
                    if (check) {
                        return check.UnloadingAreaID == item.UnloadingAreaID
                    }
                    return check == item.UnloadingAreaID
                })
            })
        },

        dailyNotifications() {
            let byDate = _.chain(this.rawNotifications)
                .filter((notification) => notification.DeletedStatus !== 98)
                .groupBy((notification) => {
                    return DateTime.fromISO(
                        notification.EstimatedArrival
                    ).toFormat('yyyy-MM-dd')
                })
                .value()

            let notifications = []

            for (let date in byDate) {
                let items = byDate[date]
                const createdCount = items.filter(
                    (item) => item.StatusDescription == 'CREATED'
                ).length
                let isImageAvailable = false
                items.forEach((item) => {
                    if (
                        item &&
                        item.PackageGroups &&
                        item.PackageGroups.length > 0
                    ) {
                        for (const group of item.PackageGroups) {
                            if (
                                group &&
                                group.Images &&
                                group.Images.length > 0
                            ) {
                                isImageAvailable = true
                            }
                        }
                    }
                })
                notifications.push({
                    start: date,
                    end: date,
                    allDay: true,
                    event_type: 'NOTIFICATION',
                    destinationContainerID: items[0].DestinationContainerID,
                    title: '-' + date, // -1 added in order to make sure this displays first
                    arrived_count: items.length - createdCount,
                    created_count: createdCount,
                    isImageAvailable: isImageAvailable,
                })
            }

            return notifications
        },

        waNotifications() {
            let notifications = []

            this.rawWANotifications.forEach((notification) => {
                const actor = _.find(this.rawBookings, {
                    ActorID: notification.RelatedActorID,
                })

                let dateFrom
                let dateTo
                let checkPoint
                let unloadingAreaId
                let requestedResources
                let packageGroups

                if (actor) {
                    const accessSet = actor.AccessSets[0]
                    const schedulePart = accessSet.Schedules[0].ScheduleParts[0]
                    dateFrom = DateTime.fromString(
                        schedulePart.ValidFrom,
                        this.dateTimeFormat
                    )
                    dateTo = DateTime.fromString(
                        schedulePart.ValidTo,
                        this.dateTimeFormat
                    )
                    checkPoint = accessSet.Checkpoint
                    unloadingAreaId = accessSet.UnloadingAreaID
                    requestedResources = accessSet.RequestedResources
                    packageGroups = actor.PackageGroups
                }

                notifications.push({
                    ...actor,
                    ...notification,
                    DateFrom: dateFrom,
                    DateTo: dateTo,
                    UnloadingArea: checkPoint,
                    UnloadingAreaID: unloadingAreaId,
                    requestedResources: requestedResources,
                    PackageGroups: packageGroups,
                    start: notification.ActualArrival
                        ? notification.ActualArrival
                        : notification.EstimatedArrival,
                    end: notification.ActualArrival
                        ? notification.ActualArrival
                        : notification.EstimatedArrival,
                    allDay: true,
                    event_type: 'WA_NOTIFICATION',
                    destinationContainerID: notification.DestinationContainerID,
                })
            })

            if (this.selectedWaitingAreaTypes.length === 0) {
                this.notifications = []
            }

            const filtered = notifications.filter((item) => {
                return this.selectedWaitingAreaTypes.some((check) => {
                    return check === item.Status
                })
            })

            // Custom sorting as per Status = [0, 3, 1, 2]
            let ordering = {}
            const customSortOrder = [0, 3, 1, 2]
            for (let i = 0; i < customSortOrder.length; i++) {
                ordering[customSortOrder[i]] = i
            }
            filtered.sort((a, b) => {
                return ordering[a.Status] - ordering[b.Status]
            })

            // Booking calendar events are sorted by title
            filtered.map((item, index) => {
                item.title = index
                return item
            })

            return filtered
        },

        calendarBookings() {
            const bookings = this.bookings.map((booking) => {
                let diff = booking.DateTo.diff(booking.DateFrom).as('days')
                let sDate = booking.DateFrom.toISO()
                let eDate = booking.DateTo.toISO()
                if (diff >= 1) {
                    eDate = booking.DateTo.plus({ days: 1 }).toISO()
                }
                return {
                    ...booking,
                    title: booking.BookingReference,
                    start: sDate,
                    end: eDate,
                    allDay: diff >= 1,
                    showPopover: false,
                }
            })
            return [
                ...this.dailyNotifications,
                ...bookings,
                ...this.waNotifications,
            ]
        },

        config() {
            let scrollTime = '06:00:00'

            let dayOfWeek = DateTime.local().weekday
            this.isWeekend = dayOfWeek == 6 || dayOfWeek == 7

            return {
                locale: this.selectedLanguage.isoName.substring(0, 2),
                scrollTime,
                firstDay: 1,
                slotLabelFormat: 'HH:mm',
                timezone: 'local',
                eventOverlap: true,
                defaultView: this.isWeekend
                    ? 'agendaSevenDays'
                    : 'agendaFiveDays',
                schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
                views: {
                    agendaFiveDays: {
                        type: 'agendaWeek',
                        weekends: false,
                    },

                    agendaSevenDays: {
                        type: 'agendaWeek',
                    },
                },
                columnHeaderHtml(m) {
                    return `
                        <div>
                            <span class="calendar__day-text">${m.format(
                                'ddd'
                            )}</span>
                            <span class="calendar__day-number">${m.format(
                                'DD'
                            )}</span>
                        </div>
                    `
                },
            }
        },

        today() {
            return DateTime.local().toJSDate()
        },

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        ...mapGetters([
            'selectedLanguage',
            'selectedContainer',
            'collapseBooking',
        ]),
    },

    mounted() {
        const hidePopovers = _.throttle(() => {
            this.hideCalendarPoppers()
        }, 100)

        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('scroll', hidePopovers, true)
        })
    },

    watch: {
        async selectedContainer(container) {
            await this.fetchBookings(container, this.dateTimeRange)
            this.fetchNotifications(container, this.dateTimeRange)
            if (this.selectedContainer.AvailableBookingTypes.includes('WA')) {
                this.fetchWANotifications(container, this.dateTimeRange)
            }
        },

        selectedLanguage() {
            Vue.nextTick(() => {
                this.$refs.bookingCalendar.$emit('rerender-events')

                $('#calendar').fullCalendar(
                    'option',
                    'locale',
                    this.selectedLanguage.isoName.substring(0, 2)
                )
            })
        },

        weekOfYear(week) {
            this.fetchByWeekNumber(week)
        },

        date() {
            if (this.defaultView === 'agendaDay') {
                this.$refs.bookingCalendar.fireMethod('gotoDate', this.date)
            } else {
                this.weekOfYear = DateTime.fromISO(
                    this.date.toISOString()
                ).weekNumber
            }
        },
    },

    methods: {
        ...mapActions(['setBookingCollapsed']),

        handleCheckBoxChange() {
            this.$store.commit(
                'setBookingDetails',
                this.$store.state.bookingDetails
            )
        },
        handleBookingDetailsHighlightChange() {
            this.$store.commit(
                'setBookingDetails',
                this.$store.state.bookingDetails
            )
        },

        fireEvent(event, ...data) {
            Events.$emit(event, ...data)
        },

        colorLuminance(hex, lum) {
            // validate hex string
            hex = String(hex).replace(/[^0-9a-f]/gi, '')
            if (hex.length < 6) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
            }
            lum = lum || 0

            // convert to decimal and change luminosity
            var rgb = '#',
                c,
                i
            for (i = 0; i < 3; i++) {
                c = parseInt(hex.substr(i * 2, 2), 16)
                c = Math.round(
                    Math.min(Math.max(0, c + c * lum), 255)
                ).toString(16)
                rgb += ('00' + c).substr(c.length)
            }

            return rgb
        },

        renderBooking(booking, element) {
            this.hideCalendarPoppers()

            let instance = null

            if (!booking._id) {
                instance = new BookingCreateEvent({
                    propsData: {
                        booking,
                        element,
                    },
                })
            } else if (booking.event_type === 'NOTIFICATION') {
                instance = new BookingNotificationEvent({
                    propsData: {
                        booking,
                        element,
                    },
                })
            } else if (booking.event_type === 'WA_NOTIFICATION') {
                instance = new WANotificationEvent({
                    propsData: {
                        booking,
                        selectedContainer: this.selectedContainer,
                        element,
                        trans: this.$t,
                    },
                })

                instance.$on('update-booking', (booking) =>
                    this.updateBooking(booking)
                )

                instance.$on('actor-editing', (booking) =>
                    this.selectEditBooking(booking)
                )
            } else {
                instance = new BookingEvent({
                    propsData: {
                        booking,
                        element,
                        filters: this.bookingDetailsArr,
                        trans: this.$t,
                        unloadingArea: this.findUnloadingAreaByID(
                            booking.UnloadingAreaID
                        ),
                    },
                })

                instance.$on('delete-booking', (booking) =>
                    this.deleteBooking(booking)
                )

                instance.$on('actor-editing', (booking) =>
                    this.selectEditBooking(booking)
                )
            }

            instance.$mount()
            element.eq(0).find('.fc-content').html(instance.$el)
        },

        hideCalendarPoppers() {
            for (const popper of document.querySelectorAll('.tippy-popper')) {
                const instance = popper._tippy

                if (instance && instance.state.visible) {
                    instance.popperInstance.disableEventListeners()
                    instance.hide()
                }
            }
        },

        selectBooking(booking) {
            if (booking.event_type === 'NOTIFICATION') {
                Events.$emit('notification-show', booking)
                return
            }
        },

        selectEditBooking(booking) {
            if (booking.event_type === 'NOTIFICATION') {
                Events.$emit('notification-show', booking)
                return
            }

            Events.$emit('calendar-editing', booking)
        },

        addBooking({ start, end }) {
            Events.$emit('calendar-creating', {
                dateRange: [start, end],
                unloadingArea: this.selectedUnloadingArea,
            })
        },

        async updateBooking(booking) {
            const startDate = DateTime.fromISO(
                booking.start.toDate().toISOString()
            ).toFormat(this.dateTimeFormat)

            const endDate = DateTime.fromISO(
                booking.end.toDate().toISOString()
            ).toFormat(this.dateTimeFormat)

            let accessSet
            if (booking.ActorType === 'PASS') {
                accessSet = _.cloneDeep(booking.AccessSets)
                accessSet = _.map(
                    accessSet,
                    _.partial(_.omit, _, [
                        'AccessSetID',
                        'Checkpoint',
                        'GeoLocation',
                        'UnloadingAreaID',
                        'UnloadingArea',
                        'ScheduleTemplates',
                    ])
                )
                accessSet.forEach((set) => {
                    set.RequestedResources = _.map(
                        set.RequestedResources,
                        'ResourceType'
                    )
                    set.Schedules = _.map(
                        set.Schedules,
                        _.partial(_.omit, _, ['ScheduleID'])
                    )
                    set.Schedules.forEach((schedule) => {
                        schedule.ScheduleParts = _.map(
                            schedule.ScheduleParts,
                            _.partial(_.omit, _, [
                                'SchedulePartID',
                                'PostFlex',
                                'StopFlex',
                                'UsageTimes',
                                'MaxUsageTimes',
                                'IsCurrentlyPermittingAccess',
                            ])
                        )
                        schedule.ScheduleParts.forEach((part) => {
                            part.ValidFrom = startDate
                            part.ValidTo = endDate
                        })
                    })
                })
            } else {
                let accessSet1 = _.cloneDeep(booking.AccessSets[0])
                accessSet1.CheckPointID = null
                accessSet1 = _.omit(accessSet1, [
                    'AccessSetID',
                    'Checkpoint',
                    'GeoLocation',
                    'UnloadingArea',
                    'ScheduleTemplates',
                ])
                accessSet = [accessSet1]
                accessSet1.RequestedResources = _.map(
                    accessSet1.RequestedResources,
                    'ResourceType'
                )
                if (
                    accessSet &&
                    accessSet.length > 0 &&
                    accessSet[0].Schedules &&
                    accessSet[0].Schedules[0].ScheduleParts
                ) {
                    accessSet[0].Schedules = _.map(
                        accessSet[0].Schedules,
                        _.partial(_.omit, _, ['ScheduleID'])
                    )
                    accessSet[0].Schedules[0].ScheduleParts = _.map(
                        accessSet[0].Schedules[0].ScheduleParts,
                        _.partial(_.omit, _, [
                            'SchedulePartID',
                            'PostFlex',
                            'StopFlex',
                            'UsageTimes',
                            'MaxUsageTimes',
                            'IsCurrentlyPermittingAccess',
                        ])
                    )
                    accessSet[0].Schedules[0].ScheduleParts[0].ValidFrom =
                        startDate
                    accessSet[0].Schedules[0].ScheduleParts[0].ValidTo = endDate
                }
            }

            let payload = {
                ActorType: booking.ActorType,
                Email: booking.Email === null ? '' : booking.Email,
                FirstName: booking.FirstName,
                LastName: booking.LastName,
                MAIsEnabled: booking.MAIsEnabled,
                Comment: booking.Comment,
                PinCode: booking.PinCode,
                PlateNo: booking.PlateNo,
                Phone: booking.Phone,
                Company: booking.Company,
                LocationValidationDisabled: booking.LocationValidationDisabled,
                MaxUsageTimes: booking.MaxUsageTimes,
                UnloadingTimeInMins: booking.UnloadingTimeInMins,
                AccessSets: accessSet,
                PackageGroups: booking.PackageGroups,
                IsLocked: booking.IsLocked,
                Status: booking.Status,
            }

            let response = await this.$http.put(
                `/Actor/${booking.ActorID}`,
                payload
            )
            if (response && response.status === 200) {
                // this.fetchByWeekNumber(this.weekOfYear)
                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.updated', {
                        section: this.$i18n.i18next.t('text.booking'),
                    }),
                })
            } else {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.error.general'),
                })
            }
        },

        async fetchByDateTimeRange(range) {
            this.activeButton = ''
            await this.fetchBookings(this.selectedContainer, range)
            this.fetchNotifications(this.selectedContainer, range)
            if (this.selectedContainer.AvailableBookingTypes.includes('WA')) {
                this.fetchWANotifications(this.selectedContainer, range)
            }

            this.$nextTick(() => {
                if (this.$refs.bookingCalendar) {
                    this.$refs.bookingCalendar.fireMethod('gotoDate', this.date)
                }
            })

            this.$nextTick(() => {
                this.modifyAllAreaStyles()
            })
        },

        findUnloadingAreaByID(id) {
            return _.find(this.unloadingAreas, { UnloadingAreaID: id })
        },

        async fetchBookings(container = null, range = []) {
            container = container ? container : this.selectedContainer

            if (!_.isEmpty(container)) {
                range = range.length ? range : this.currentWeekRange

                let dateTimeFrom = DateTime.fromISO(range[0].toISOString())
                let dateTimeTo = DateTime.fromISO(range[1].toISOString())

                // set end and start time to day start and day end if it doesn't contains time
                if (
                    dateTimeFrom.startOf('day').valueOf() ===
                        dateTimeFrom.valueOf() &&
                    dateTimeTo.startOf('day').valueOf() === dateTimeTo.valueOf()
                ) {
                    let start = dateTimeFrom.startOf('day')
                    let end = dateTimeTo.endOf('day')

                    dateTimeFrom = start.toFormat(this.dateTimeFormat)
                    dateTimeTo = end.toFormat(this.dateTimeFormat)

                    range = [start.toJSDate(), end.toJSDate()]
                } else {
                    dateTimeFrom = dateTimeFrom.toFormat(this.dateTimeFormat)
                    dateTimeTo = dateTimeTo.toFormat(this.dateTimeFormat)
                }

                let unloadingAreasIdList = []
                this.unloadingAreas
                    .filter((area) => area.IsActive)
                    .map((area) => {
                        unloadingAreasIdList.push(area.UnloadingAreaID)
                    })

                let { data } = await this.$http.post(`Actor/Search`, {
                    ValidFrom: dateTimeFrom,
                    ValidTo: dateTimeTo,
                    ActorTypeFilter: ['PASS', 'SLOT', 'MILKRUN', 'TENTATIVE'],
                    DestinationContainerFilter: [container.ContainerID],
                    IncludeOptionalItems: ['PACKAGE_GROUPS_ITEMS'],
                    UnloadingAreaFilter: unloadingAreasIdList,
                })

                this.rawBookings = data
                this.dateTimeRange = range
            }
        },

        async fetchNotifications(container = null, range = []) {
            container = container ? container : this.selectedContainer

            if (!_.isEmpty(container)) {
                range = range.length ? range : this.currentWeekRange

                let dateTimeFrom = DateTime.fromISO(range[0].toISOString())
                let dateTimeTo = DateTime.fromISO(range[1].toISOString())

                // set end and start time to day start and day end if it doesn't contains time
                if (
                    dateTimeFrom.startOf('day').valueOf() ===
                        dateTimeFrom.valueOf() &&
                    dateTimeTo.startOf('day').valueOf() === dateTimeTo.valueOf()
                ) {
                    let start = dateTimeFrom.startOf('day')
                    let end = dateTimeTo.endOf('day')

                    dateTimeFrom = start.toFormat(this.dateTimeFormat)
                    dateTimeTo = end.toFormat(this.dateTimeFormat)

                    range = [start.toJSDate(), end.toJSDate()]
                } else {
                    dateTimeFrom = dateTimeFrom.toFormat(this.dateTimeFormat)
                    dateTimeTo = dateTimeTo.toFormat(this.dateTimeFormat)
                }

                let { data } = await this.$http.get(
                    `Container/${container.ContainerID}/BLCNotification/From/${dateTimeFrom}/To/${dateTimeTo}`
                )

                this.rawNotifications = data
                this.dateTimeRange = range
            }
        },

        async fetchWANotifications(container = null, range = []) {
            container = container ? container : this.selectedContainer

            if (!_.isEmpty(container)) {
                range = range.length ? range : this.currentWeekRange

                let dateTimeFrom = DateTime.fromISO(range[0].toISOString())
                let dateTimeTo = DateTime.fromISO(range[1].toISOString())

                // set end and start time to day start and day end if it doesn't contains time
                if (
                    dateTimeFrom.startOf('day').valueOf() ===
                        dateTimeFrom.valueOf() &&
                    dateTimeTo.startOf('day').valueOf() === dateTimeTo.valueOf()
                ) {
                    let start = dateTimeFrom.startOf('day')
                    let end = dateTimeTo.endOf('day')

                    dateTimeFrom = start.toFormat(this.dateTimeFormat)
                    dateTimeTo = end.toFormat(this.dateTimeFormat)

                    range = [start.toJSDate(), end.toJSDate()]
                } else {
                    dateTimeFrom = dateTimeFrom.toFormat(this.dateTimeFormat)
                    dateTimeTo = dateTimeTo.toFormat(this.dateTimeFormat)
                }

                let { data } = await this.$http.get(
                    `Container/${container.ContainerID}/WANotification/From/${dateTimeFrom}/To/${dateTimeTo}`
                )

                this.rawWANotifications = data
                this.dateTimeRange = range
            }
        },

        async deleteBooking(actor) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: this.$i18n.i18next.t('text.booking'),
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )

                await this.$http.delete(`Actor/${actor.ActorID}`)
                await this.fetchByWeekNumber(this.weekOfYear)

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: this.$i18n.i18next.t('text.booking'),
                    }),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else if (e.response.status == 488) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: e.response.data,
                    })
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        actorType(type = '') {
            if ('milkrun' === type.toLowerCase()) {
                return this.$i18n.i18next.t('text.milkrun').toUpperCase()
            }

            return type
        },

        fetchByWeekNumber(week) {
            let dateByWeek = DateTime.fromISO(this.date.toISOString()).set({
                weekNumber: week,
            })

            this.dateTimeRange = [
                dateByWeek.startOf('week').toJSDate(),
                dateByWeek.endOf('week').toJSDate(),
            ]

            this.fetchByDateTimeRange(this.dateTimeRange)
        },

        prevWeek() {
            let prev = DateTime.fromISO(this.date.toISOString()).minus({
                days: 7,
            })

            this.date = prev.toJSDate()
            this.weekOfYear = prev.weekNumber
        },

        nextWeek() {
            let next = DateTime.fromISO(this.date.toISOString()).plus({
                days: 7,
            })

            this.date = next.toJSDate()
            this.weekOfYear = next.weekNumber
        },

        unloadingAreasChecked(data) {
            this.unloadingAreaList = data
        },

        setSelectedUnloadingArea(data) {
            this.selectedUnloadingArea = data
        },

        modifyAllAreaStyles() {
            const allDayAreaElement =
                this.$refs.bookingCalendar.$el.getElementsByClassName(
                    'fc-content-skeleton'
                )[0]
            if (allDayAreaElement) {
                allDayAreaElement.style.maxHeight = '300px'
                allDayAreaElement.style.overflowY = 'auto'
                allDayAreaElement.style.overflowX = 'hidden'
            }
        },
    },
}
</script>
<style>
.custom_font_1 {
    font-size: 0.79em;
    font-weight: bold;
}

.button {
    margin-top: 35px;
}

.flip-list-move {
    transition: transform 0.5s;
}

.no-move {
    transition: transform 0s;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

.list-group {
    min-height: 20px;
}

.list-group-item {
    cursor: move;
}

.list-group-item i {
    cursor: pointer;
}

.draggable_icon {
    color: #e4e5e7;
    font-size: 16px;
    padding-top: 6px;
    padding-right: 6px;
}
.highlight_section {
    margin-left: 120px;
}
.input-group label {
    display: table;
}
.theme--light .input-group:not(.input-group--error) label {
    min-width: 110px;
}
.icon-default {
    cursor: pointer;
}
.icon-default:hover {
    color: #38a196;
}
.fc-view.fc-agendaDay-view.fc-agenda-view .fc-widget-header {
    margin-bottom: 30px !important;
}
.btn-calendar-auto {
    z-index: 10;
}
.btn-calendar-sm {
    z-index: 10;
}
.top-calendar-picker {
    z-index: 10;
}

.wa-type-selector-proposed {
    background: #fffe40;
    border-color: #000000;
    border-style: dashed;
    border-width: 2px;
}
.wa-type-selector-expected {
    background: #30b1ea;
    border-color: #ffffff;
    border-style: dashed;
    border-width: 2px;
}
.wa-type-selector-confirmed {
    background: #3fd2be;
    border-color: #ffffff;
    border-width: 2px;
    color: #ffffff;
}
.wa-type-selector-denied {
    background: #f80701;
    border-color: #ffffff;
    border-width: 2px;
    color: #ffffff;
}
.wa-type-selector {
    margin-left: 12px;
    margin-bottom: 5px;
    padding: 1px 5px 1px 5px;
    font-weight: 500;
    width: 130px;
}
.badge__badge,
.badge__badge .icon {
    top: -2px !important;
    right: -5px !important;
    height: 15px !important;
    width: 15px !important;
    font-size: 8px !important;
    line-height: 1px !important;
    font-weight: bold !important;
}
.booking-details label {
    white-space: pre-wrap;
    line-height: 17px;
    font-size: 13px !important;
    margin-top: 5px;
}
</style>
